import FieldGoalStats from "./field-goal-stats";

export default class CflFieldGoalStats extends FieldGoalStats {
    getYardsKicked(gameContext, kickSpot) {
        return (
            ((gameContext?.homeTeamHasPossession
                ? gameContext?.getFieldLength()
                : 0) -
                kickSpot) *
            gameContext.getFieldDirectionMultiplier()
        );
    }
}
